export const site = {
  name: '看料爆料',
  fullName: '看料爆料 · 热料核实情报站',
  tagline: '真假核实 · 实锤追踪 · 辟谣速递',
  slogan: '一条料到底值不值得信，我们帮你核一遍。',
  intro:
    '看料爆料是一个专注网络热料真假的内容核实站。我们不生产瓜，只做一件事：把散落在各个平台的爆料收集起来，核对证据、追踪后续、给出判定，让每一条料都有可查的可信度依据。',
  issue: '第 214 期',
  email: 'contact@kanliaobaoliao.media',
  submitEmail: 'tips@kanliaobaoliao.media',
  updateNote: '本站内容随核实进度持续更新',
  slogan2: '少被带节奏，先看核实记录。',
  social: [
    { name: '微博', icon: 'ri-weibo-line', handle: '@看料爆料' },
    { name: '小红书', icon: 'ri-book-2-line', handle: '@看料爆料核实站' },
    { name: '邮箱订阅', icon: 'ri-mail-line', handle: 'contact@kanliaobaoliao.media' },
  ],
};

export const navLinks = [
  { to: '/', label: '首页' },
  { to: '/ranking', label: '热料榜单' },
  { to: '/debunk', label: '辟谣专题' },
  { to: '/about', label: '关于我们' },
];

export const stats = [
  { value: '1,286', label: '累计核实爆料', icon: 'ri-search-eye-line' },
  { value: '412', label: '已确认辟谣', icon: 'ri-shield-cross-line' },
  { value: '318', label: '实锤成立', icon: 'ri-shield-check-line' },
  { value: '26', label: '仍在核实', icon: 'ri-question-line' },
];

export const principles = [
  {
    title: '证据优先，结论靠后',
    desc: '没有可核对的依据，就不会给出确定结论。我们宁可写「仍在核实」，也不会为了流量下判断。',
    icon: 'ri-file-search-line',
  },
  {
    title: '完整呈现时间线',
    desc: '每条爆料都标注首次出现时间与后续进展，让读者自己看到事实是如何一步步变化的。',
    icon: 'ri-history-line',
  },
  {
    title: '区分事实与情绪',
    desc: '同样是「确有此事」，被剪辑放大和被客观记录，可信度完全不同。我们分开写清楚。',
    icon: 'ri-emotion-line',
  },
  {
    title: '公开纠错渠道',
    desc: '如果我们的判定有误，欢迎通过投稿纠错渠道指出，核实后会第一时间更正并注明。',
    icon: 'ri-refresh-line',
  },
];

export const editingStandards = [
  '所有判定都必须能追溯到至少一条可核对的依据',
  '涉及金额、比例、时间等关键数字时，注明来源与口径',
  '不确定的信息单独标注，不与已确认部分混写',
  '持续跟踪已发布内容，出现新证据时更新判定',
];

export const testimonials = [
  {
    name: '林一舟',
    role: '内容运营',
    avatar:
      'https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20a%20young%20professional%20with%20simple%20warm%20background%2C%20flat%20paper%20cutout%20style%2C%20muted%20cream%20and%20red%20palette%2C%20no%20text&width=200&height=200&seq=kanliao-avatar-01&orientation=squarish',
    quote:
      '以前看到热搜里的爆料只能凭感觉判断，现在会先来这里搜一下。有证据链和时间线的写法，读起来踏实多了。',
  },
  {
    name: '周知遥',
    role: '自由撰稿人',
    avatar:
      'https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20a%20thoughtful%20writer%20with%20simple%20warm%20background%2C%20flat%20paper%20cutout%20style%2C%20muted%20cream%20and%20olive%20palette%2C%20no%20text&width=200&height=200&seq=kanliao-avatar-02&orientation=squarish',
    quote:
      '最认可的一点是它敢写「仍在核实」。很多平台恨不得每条都下结论，这里反而更接近我需要的参考标准。',
  },
  {
    name: '沈铭',
    role: '产品经理',
    avatar:
      'https://readdy.ai/api/search-image?query=editorial%20portrait%20illustration%20of%20a%20calm%20product%20manager%20with%20simple%20warm%20background%2C%20flat%20paper%20cutout%20style%2C%20muted%20cream%20and%20amber%20palette%2C%20no%20text&width=200&height=200&seq=kanliao-avatar-03&orientation=squarish',
    quote:
      '可信度评分和判定标签很直观，扫一眼就知道这条料该不该转发给同事。省了我很多解释的力气。',
  },
];

export const faqs = [
  {
    q: '看料爆料上的「实锤」「辟谣」是怎么判定的？',
    a: '判定基于可核对的依据。如果有多条独立线索指向同一结论，我们标注为实锤成立；如果关键信息被证伪或当事人给出可信回应，标注为已辟谣；确有此事但被夸大或拼接的，标注为部分属实；证据不足或互相矛盾的，标注为仍在核实。',
  },
  {
    q: '可信度评分代表什么？',
    a: '可信度评分是对当前证据充分程度的量化参考，0 到 100 分。分数高说明有较多可核对的依据互相印证，分数低则说明目前主要依赖单一或来历不明的来源。它会随着新证据出现而更新。',
  },
  {
    q: '为什么有些爆料一直显示「仍在核实」？',
    a: '因为我们不会为了给出结论而下结论。当可核对的线索不足以支持任何一种判断时，保持「仍在核实」才是负责任的做法。我们会在有新进展时第一时间更新。',
  },
  {
    q: '我可以投稿或者指出你们的错误吗？',
    a: '非常欢迎。无论是提供新线索、补充证据，还是指出我们判定中的疏漏，都可以通过页面底部的投稿纠错表单提交。核实后我们会更正内容并注明来源。',
  },
  {
    q: '看料爆料会公开爆料的原始来源吗？',
    a: '在不影响核实的前提下，我们会尽量说明信息来源类型，例如短视频平台、职场社区或公开渠道。涉及需要保护的投稿人信息时，我们会做必要处理。',
  },
];

export const debunkTips = [
  {
    title: '先看时间，再看内容',
    desc: '大量爆料是旧图新用。核对照片与截图的拍摄时间，能过滤掉相当一部分经过包装的传言。',
    icon: 'ri-calendar-check-line',
  },
  {
    title: '截图不等于证据',
    desc: '聊天记录、通知文件都可以被修改。遇到带精确数字的截图，先问来源，再谈结论。',
    icon: 'ri-image-2-line',
  },
  {
    title: '去官方渠道搜一次',
    desc: '涉及预警、召回、通报类信息，官方渠道一定能查到对应记录，查不到就要打问号。',
    icon: 'ri-government-line',
  },
  {
    title: '警惕情绪化措辞',
    desc: '「震惊」「必须转」「删前速看」这类措辞本身就是在推动传播，而不是在提供事实。',
    icon: 'ri-alarm-warning-line',
  },
];